import React from "react";

const EntityFormActions = ({
  isSaving,
  saveStatus,
  saveProgress,
  showSuccess,
  onSave,
  onCancel,
  readOnly,
  /** Embedded in v2 explorer / light panels — sticky footer with readable contrast. */
  embedded = false,
}) => {
  const barClass = embedded
    ? "sticky bottom-0 z-30 border-t border-slate-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/90 shadow-[0_-4px_14px_rgba(15,23,42,0.08)] pb-[max(0px,env(safe-area-inset-bottom))]"
    : "fixed left-0 right-0 z-50 border-t border-gray-700 bg-gray-900/95 backdrop-blur supports-[backdrop-filter]:bg-gray-900/70";

  const innerClass = embedded
    ? "max-w-4xl mx-auto px-4 py-3 flex items-center gap-3"
    : "max-w-4xl mx-auto px-4 py-3 flex items-center gap-3";

  const progressWrapClass = embedded
    ? "flex items-center gap-2 text-xs text-slate-800 mr-auto min-w-0"
    : "flex items-center gap-2 text-xs text-blue-200 mr-auto min-w-0";

  const statusTextClass = embedded
    ? "min-w-[140px] truncate font-medium text-slate-800"
    : "min-w-[140px] truncate";

  const trackClass = embedded
    ? "w-32 shrink-0 bg-slate-200 rounded-full h-2 overflow-hidden"
    : "w-32 shrink-0 bg-blue-800/60 rounded-full h-1.5 overflow-hidden";

  const fillClass = embedded
    ? "bg-blue-600 h-2 rounded-full transition-all duration-300 ease-out"
    : "bg-blue-400 h-1.5 rounded-full transition-all duration-300 ease-out";

  const percentClass = embedded
    ? "w-10 shrink-0 text-right tabular-nums text-slate-600"
    : "w-10 shrink-0 text-right";

  const successClass = embedded
    ? "text-xs text-emerald-800 font-medium mr-auto"
    : "text-xs text-green-300 mr-auto";

  const cancelClass = embedded
    ? "px-3 py-1.5 text-sm border border-slate-300 bg-white hover:bg-slate-50 text-slate-800 rounded transition-colors disabled:opacity-50"
    : "px-3 py-1.5 text-sm bg-gray-700 hover:bg-gray-600 text-white rounded transition-colors disabled:opacity-50";

  const saveClass = embedded
    ? "px-3 py-1.5 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors disabled:opacity-50"
    : "px-3 py-1.5 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors disabled:opacity-50";

  const fixedStyle = embedded
    ? undefined
    : {
        bottom:
          "var(--mobile-chrome-bottom, env(safe-area-inset-bottom, 0px))",
      };

  return (
    <div>
      {!readOnly && (
        <div
          className={barClass}
          style={fixedStyle}
          role="status"
          aria-live="polite"
        >
          <div className={innerClass}>
            {isSaving ? (
              <div className={progressWrapClass}>
                <span className="shrink-0" aria-hidden>
                  ⏳
                </span>
                <span className={statusTextClass}>{saveStatus}</span>
                <div className={trackClass}>
                  <div
                    className={fillClass}
                    style={{ width: `${saveProgress}%` }}
                  />
                </div>
                <span className={percentClass}>{saveProgress}%</span>
              </div>
            ) : null}
            {!isSaving && showSuccess ? (
              <div className={successClass}>✅ All changes saved</div>
            ) : null}
            <div className="ml-auto flex shrink-0 items-center gap-2">
              <button
                type="button"
                onClick={onCancel}
                disabled={isSaving}
                className={cancelClass}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onSave}
                disabled={isSaving}
                className={saveClass}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EntityFormActions;
